
import dayjs from "dayjs";
import { PAGES, CROSSWORD_PUBLISHER_DATA } from "@consts";

export default {
	computed: {
		title() {
			return `Today's Crossword Clues and Answers - ${dayjs().format(
				"MMMM D, YYYY"
			)}`;
		},
		publishers() {
			if (this.$route.name !== PAGES.CLUES_PUBLISHER) {
				return CROSSWORD_PUBLISHER_DATA;
			}

			const publisherSlug = this.$route.params.publisher;

			return CROSSWORD_PUBLISHER_DATA.filter(
				(publisher) => publisher.slug !== publisherSlug
			);
		},
		isSolverLandingPage() {
			return this.$route.name === PAGES.CROSSWORD_SOLVER;
		},
	},
};
